import httpClient from "./_httpClient";

export async function getCollections({ queryKey }) {
  const url = `ac/personalization/cosmos/collections`;
  return httpClient.get(url);
}

export async function getFields({ queryKey }) {
  const [_key, { includeUserFields = false } = {}] = queryKey;
  const url = `ac/personalization/cosmos/fields?includeUserFields=${includeUserFields}`;
  return httpClient.get(url);
}

export async function getRecordsById(accountIds) {
  const url = `ac/personalization/cosmos/records-by-id`;
  return httpClient.post(url, { accountIds });
}

export async function getUserByAccountIdWithCosmosData(accountId) {
  const url = `ac/personalization/cosmos/user-by-account-id`;
  return httpClient.post(url, { accountId });
}

export async function fetchRecords({ queryKey, pageParam }) {
  const [
    _key,
    {
      filters,
      sort,
      page = undefined,
      confluenceGroup = "",
      limit = undefined,
      noHiddenUsers = true,
    },
  ] = queryKey;
  const url = `ac/personalization/cosmos/records`;

  return httpClient.post(url, {
    filters,
    page: page || pageParam,
    sort,
    limit,
    confluenceGroup,
    noHiddenUsers,
  });
}

export async function filterCollectionsUserIsPartOf({ queryKey }) {
  const [_key, { collections }] = queryKey;
  const url = `ac/personalization/cosmos/filter-collections-user-is-part-of`;

  return httpClient.post(url, { collections });
}

export async function isCosmosEnabled({ queryKey }) {
  const url = `ac/personalization/cosmos/client-exists`;
  return httpClient.get(url);
}

export async function getWidgetSettingByKey({ queryKey }) {
  const [_key, { widgetId }] = queryKey;
  const url = `ac/personalization/cosmos/widget/setting?widgetId=${widgetId}`;
  return httpClient.get(url);
}
